module.exports={
    "color": {
        "white": "#ffffff",
        "black": "#000000",
        "lighter-blue": "#F1F5F8",
        "light-blue": "#00ACF4",
        "dark-blue": "#111B54",
        "darker-grey": "#596A83",
        "light-grey": "#C9D4E3",
        "dark-grey-tint": "#EFF0F6",
        "cyan": "#74DDED",
        "grey": "#C9D4E3",
        "light-purle": "#8D96C7"
    },
    "space": {
        "quarter": "2px",
        "half": "4px",
        "default": "8px",
        "secondary": "12px",
        "double": "16px",
        "triple": "24px",
        "quad": "32px",
        "double-triple": "48px",
        "big": "56px",
        "double-quad": "64px",
        "wide": "80px"
    },
    "padding": {},
    "position": {},
    "font": {
        "base": "'IBM Plex Sans', Arial, sans-serif"
    },
    
    "font-size": {
        "xsmall": "0.65rem",
        "small": "0.85rem",
        "base": "1rem",
        "medium": "1.125rem",
        "large": "1.75rem",
        "xlarge": "2.25rem"
    },

    "": {
        "global-radius": "8px",
        "bordered": "1px #e2e2e2 solid",
        "default-icon-size": "16px",
        "transparent": 0,
        "semi-transparent": 0.6,
        "opaque": 1
    }
}